import React, { Component, memo } from "react";
import { connect } from "react-redux";
import {
  getHomePageStructure,
  getEpg,
  getLiveStreamData,
  getAutoRailHome,
  getEpgInitialLoad,
  getHomePageStructureInitialLoad,
  getLiveStreamDataInitialLoad,
  resetEpgData,
  setSignupModalStatus
} from "../../actions";
import HelmetComponent from "../../components/shared/Helmet";
import Player from "../../components/shared/Player";
import Rail from "../../components/shared/Rail";
import AppDownload from "../../components/common/appDownload";
import Newsletter from "../../components/common/newsletter";
import PodCast from "../../components/common/podCast";
import { axiosContentDetail } from "../../axios";
import EPG from "./Epg";
import {
  getCurrentSlide,
  IsEmpty,
  checkLiveStream,
  epgSlide,
  getParameterByName,
  sparkLoopReferralHandler,
  signUpAnalytics,
  followButtonClicked,
  redirectionWrapper,
  getSeriesDescHtml,
  isEmptyArray,
  generateStructuredData,
} from "../../util/commonFunctions";
import { getRailTheme } from "../../util/themeHelper"
import PlayerOverlay from "../../components/common/playerOverlay";
import { SponsoredContentComponent } from "../../components/shared/SponsoredContent";
import { getContentWithLanguage } from "../../util/language";
import { getEnv } from "../../../helpers/env";
import { handleActionError } from "../../util/error";

let intervalId;
let epgInterval;

class Home extends Component {
  constructor(props) {
    super(props);
    this.props.resetEpgData();
  }
  state = {
    railData: null,
    playerData: null,
    epgData: [
      { data: null, class: "active" },
      { data: null, class: "" }
    ],
    currentShowData: null,
    currentSlideNumber: "0",
    showLive: true,
    isSetHome: false,
    isSetEpg: false,
    enableOverlay: false,
    slideNum: 0,
    descHeight: 350,
    structuredData: null
  };

  getSchedule = () => {
    this.setToday();
    this.props.showScheduleToggler();
  };

  setToday = () => {
    let tempEpg = [...this.state.epgData];
    tempEpg[0].class = "active";
    tempEpg[1].class = "";
    this.setState({
      epgData: tempEpg
    });
  };

  setTomorrow = () => {
    let tempEpg = [...this.state.epgData];
    tempEpg[1].class = "active";
    tempEpg[0].class = "";
    this.setState({
      epgData: tempEpg
    });
  };

  setEpg = () => {
    // console.log("this.props.epgData", this.props.epgData);
    if (!this.props.epgData) {
      return false;
    }
    clearInterval(epgInterval);
    let tempEpg = [...this.state.epgData];
    let slidenumber = getCurrentSlide(this.props.epgData.today);
    tempEpg[0].data = this.props.epgData.today || [];
    tempEpg[1].data = this.props.epgData.tomorrow || [];
    this.setState(prevState => {
      return {
        isSetEpg: true,
        epgData: tempEpg,
        currentShowData: epgSlide(slidenumber, this.props.epgData)
          ? this.props.epgData.today[slidenumber]
          : null,
        currentSlideNumber: epgSlide(slidenumber, this.props.epgData)
          ? slidenumber
          : prevState.currentSlideNumber,
        showLive: epgSlide(slidenumber, this.props.epgData) ? true : false,
      };
    }, () => {
      this.handleLoad();
      let currentTime = Date.now();
      let intervalTime = this.state.currentShowData ? (this.state.currentShowData?.endDateTime - currentTime) : 60000
      if (!IsEmpty(this.props.epgData?.today)) {
        epgInterval = intervalTime && setInterval(() => {
          this.setEpg()
        }, intervalTime);
      }
    });
  };

  enableOverlayFun = () => {
    localStorage.setItem("liveStreamOverlay", "true-" + Date.now());
    this.setState({
      enableOverlay: true
    });
    if (!this.props.signUpModalStatus) {
      this.openSigninModalPopup("signin");
    }
  };

  openSigninModalPopup = (requestedForm) => {
    this.props.setSignupModalStatus(true, requestedForm);
  };

  toggleText = () => {
    let descHgt = document.querySelector('.livetv-info-toggle');
    let infoHeight = descHgt.scrollHeight;
    let btnText = document.querySelector(".toggle-text");
    if (btnText.innerHTML === "show more") {
      btnText.innerHTML = "show less";
    } else {
      btnText.innerHTML = "show more";
    }
    descHgt.style.setProperty('--max-height', infoHeight + 'px');
    descHgt.classList.toggle("is-visible");
  }

  handleLoad = () => {
    let descHgt = document.querySelector('.livetv-info-toggle');
    if (descHgt?.scrollHeight) {
      this.setState({
        descHeight: descHgt.scrollHeight
      });
    }
  }

  returnStructuredData = (structuredDataArr) => {
    this.setState({
      structuredData: `{
        "@context":"https://schema.org",
        "@graph": [${structuredDataArr}]
      }`
    });
  }

  homeStructure = () => {
    const refThis = this;
    const refHomeData = this.props.homePageData;
    if (!refHomeData){
      return <></>;
    }
    const promises = refHomeData.map(async (value, index) => {
      if (value.railType && value.railType.toLowerCase() === "auto" && !IsEmpty(value.contentApiUrl)) {
        try {
          const vodResponse = await axiosContentDetail.get(
            value.contentApiUrl + "?offset=0&max=" + value.numberOfVODs
          );
          const filteredByLanguage = getContentWithLanguage(vodResponse.data.data, this.props.currentLanguage);
          return filteredByLanguage;
        } catch (error) {
          handleActionError("An error occurred getting home page VOD data", error);
          return null;
        }
      }
      return new Promise(function (resolve, reject) {
        resolve(value);
      });
    });

    // console.log("Calling promises to get rails..")
    let structuredDataArr = [];
    Promise.all(promises)
      .then((values) => {
        let themeIndex = 0;
        let rails = values.map((railValue, index) => {
          // console.log("Rail value:", railValue);
          const theme = getRailTheme(themeIndex);
          switch (true) {
            case railValue === null:
              return (<></>);
            case railValue.railType &&
              railValue.railType.toLowerCase() == "custom":
              if (!isEmptyArray(railValue.contentList)){
                const structuredData = generateStructuredData(railValue.contentList.slice(0, railValue.numberOfVODs));
                
                structuredDataArr.push(structuredData);

                const rail = (
                  <Rail
                    key={"manual" + index}
                    theme={theme}
                    manualRailId={values.id}
                    title={railValue.title}
                    data={
                      railValue.contentList
                        ? railValue.contentList.slice(0, railValue.numberOfVODs)
                        : []
                    }
                    railId={refHomeData[index].id}
                    railType="manual_rail"
                    showSeeAll={true}
                  />
                );
                themeIndex++;
                return rail;
              } else {
                return (<></>)
              }
            case refHomeData[index].railType &&
              refHomeData[index].railType.toLowerCase() == "auto" &&
              refHomeData[index].subType &&
              refHomeData[index].subType.toLowerCase() == "latest":
              if (!isEmptyArray(railValue)){
                const structuredData = generateStructuredData(railValue);

                structuredDataArr.push(structuredData);

                const rail = (
                  <Rail
                    key={"latest" + index}
                    theme={theme}
                    title={refHomeData[index].title}
                    railId={refHomeData[index].id}
                    data={railValue ? railValue : []}
                    railType="latest_rail"
                    showSeeAll={true}
                  />
                );
                themeIndex++;
                return rail;
              } else {
                return (<></>);
              }
            case refHomeData[index].railType &&
              refHomeData[index].railType.toLowerCase() == "auto" &&
              refHomeData[index].subType &&
              refHomeData[index].subType.toLowerCase() == "topic_driven":
              if (!isEmptyArray(railValue.contentResults)){
                const structuredData = generateStructuredData(railValue.contentResults);
                
                structuredDataArr.push(structuredData);
              
                const rail = (
                  <Rail
                    key={"topic" + index}
                    theme={theme}
                    title={refHomeData[index].title}
                    railId={refHomeData[index].id}
                    seeAllUrl={refHomeData[index].topic}
                    data={
                      railValue.contentResults
                        ? railValue.contentResults
                        : []
                    }
                    subType={refHomeData[index].subType.toLowerCase()}
                    railType="latest_rail"
                    showSeeAll={true}
                  />
                );
                themeIndex++;
                return rail;
              } else {
                return (<></>);
              }
            case refHomeData[index].railType &&
              refHomeData[index].railType.toLowerCase() == "auto" &&
              refHomeData[index].subType &&
              refHomeData[index].subType.toLowerCase() == "series_driven":
              if (!isEmptyArray(railValue.contentResults)){                
                const structuredData = generateStructuredData(railValue.contentResults);
                
                structuredDataArr.push(structuredData);

                const rail = (
                  <Rail
                    key={"series" + index}
                    theme={theme}
                    title={refHomeData[index].title}
                    railId={refHomeData[index].id}
                    seeAllUrl={refHomeData[index].topic}
                    data={
                      railValue.contentResults
                        ? railValue.contentResults
                        : []
                    }
                    subType={refHomeData[index].subType.toLowerCase()}
                    railType="latest_rail"
                    showSeeAll={true}
                  />
                );
                themeIndex++;
                return rail;
              } else {
                return (<></>);
              }
            case refHomeData[index].sectionType.toLowerCase() ==
              "app_download_info":
              return (
                <AppDownload
                  key={"app_download" + index}
                  theme={theme}
                />
              );
            case refHomeData[index].sectionType.toLowerCase() ==
              "newsletter":
              return (
                <Newsletter
                  key={"newsletter" + index}
                  theme={theme}
                />
              );
            case refHomeData[index].sectionType.toLowerCase() == "podref":
              return (
                <PodCast
                  key={"podcast" + index}
                  theme={theme}
                />
              );
            case refHomeData[index].sectionType.toLowerCase() == "cta":
              if (railValue.ctaList.length > 0){
                const rail = (
                  <div className={`${theme} sponsored`}>
                    <div className="container">
                      <div className="row">
                        <SponsoredContentComponent
                          key={"sponsored" + index}
                          sponsoredBy={
                            railValue &&
                            railValue.ctaList[0] &&
                            railValue.ctaList[0]
                          }
                        />
                      </div>
                    </div>
                  </div>
                );
                themeIndex++;
                return rail;
              } else {
                return (<></>);
              }
             
            default:
              break;
          }
        });

        if (structuredDataArr.length > 0) {
          this.returnStructuredData(structuredDataArr);
        }
      
        refThis.setState({
          railData: rails,
          isSetHome: true
        });
      })
      .catch(err => {
        console.error("Error occurred getting data for each rail:", err);
        return false;
      });
  };

  componentDidMount = async () => {
    // --> Signup analytics code
    if(this.props.homePageData && this.props.homePageData.length > 0) {
      this.homeStructure()
    }
    if (localStorage.getItem("firebaseSignupEvent")) {
      signUpAnalytics();
    }
    // Signup analytics code --<

    const query = new URLSearchParams(this.props.location.search);
    const signInSuccessToken = query.get('sucessToken');
    if (signInSuccessToken) { // redirection logic runs only if we recieve successtoken in url
      this.redirectToSavedLocation(localStorage.getItem("userLastKnownLocation"));
    }

    const { match: { url } = {}, location: { search } = {}, currentLanguage } = this.props;

    if (!IsEmpty(localStorage.getItem("token"))) {
      this.props.getEpg(localStorage.getItem("token"), currentLanguage);
    } else if (signInSuccessToken) {
      this.props.getEpg(signInSuccessToken, currentLanguage);
    } else {
      this.props.getEpg(null, currentLanguage);
    }

    this.setState({
      isSetEpg: false
    });

    if (!this.props.liveStreamData) {
      this.props.getLiveStreamData();
    }
    // console.log("Home page data props", this.props.homePageData);
    if (!this.props.homePageData) {
      this.props.getHomePageStructure(this.props.currentLanguage);
    }
    if (IsEmpty(localStorage.getItem("token"))) {
      let RH_REFLINK = getParameterByName("rh_ref", search || url);
      if (RH_REFLINK) { // referral code found before login
        localStorage.setItem("RH_REFLINK", RH_REFLINK);
      }
    }
    setTimeout(
      () => this.handleLoad(),
      1000
    );
  };


  componentWillReceiveProps(nextProps) {
    if (nextProps.userProfile != this.props.userProfile) {
      if (!IsEmpty(localStorage.getItem("token"))) {
        if (!IsEmpty(localStorage.getItem("RH_REFLINK")) && localStorage.getItem("isOldUser") == "false") { // user referral code found after login
          sparkLoopReferralHandler(localStorage.getItem("RH_REFLINK"), localStorage.getItem("token"), nextProps.userProfile.email);
        }
      } else { // user logged out from home page
        window.location.reload();
      }
    }
  }

  redirectToSavedLocation = (savedLocation) => {
    if (savedLocation && decodeURIComponent(savedLocation) !== getEnv("BASE_URL") + '/') {
      window.location.href = savedLocation;
    } else {
      this.props.history.push("/");
    }
  }

  updateStartPosition = () => {
    //this.getEpg();
  };

  followObject = (objectId, objectType) => {
    if (localStorage.getItem("token")) {
      if (objectType == "company") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
      } else if (objectType == "expert") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
      } else if (objectType == "topic") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
      } else if (objectType == "series") {
        followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
      }
    } else {
      let followObject = { objectId: objectId, objectType: objectType };
      localStorage.setItem("followObject", JSON.stringify(followObject));
      this.openSigninModalPopup("signin");
    }
  }

  followButtonClickedRespHandler = (response, error) => {
    if (response) {
      this.updateFollowBtnStatus(response.objectId, response.objectType);
    }
  }

  updateFollowBtnStatus = (objectId, objectType) => {

    if (objectType == 'expert') {
      let updated_experts = [];
      Object.values(this.state.currentShowData.experts).map(values => {
        if (values?.id == objectId) {
          values.isFollowing = !values.isFollowing;
        }
        updated_experts.push(values);
      });
      this.setState(prevState => ({
        currentShowData: {                   // object that we want to update
          ...prevState.currentShowData,    // keep all other key-value pairs
          experts: updated_experts       // update the value of specific key
        }
      }))
    }

    if (objectType == 'series') {
      let updated_series = {};
      updated_series = this.state.currentShowData.eventSeries;
      updated_series.isFollowing = !this.state.currentShowData.eventSeries.isFollowing;
      this.setState(prevState => ({
        currentShowData: {                   // object that we want to update
          ...prevState.currentShowData,    // keep all other key-value pairs
          eventSeries: updated_series       // update the value of specific key
        }
      }))
    }
  }

  componentWillUnmount = () => {
    clearInterval(epgInterval);
    clearInterval(intervalId);
  };

  render = () => {
    return (
      <React.Fragment>
        <HelmetComponent
          showLive={this.state.showLive}
          startPosition={this.state.currentSlideNumber}
          data={this.state.epgData}
          slideNumber={(this.props.epgData && this.props.epgData.slideNumber) || 0}
          videoUrl={
            this.props.liveStreamData &&
            this.props.liveStreamData.videoLiveStreamURL
          }
          noIndex="false"
          structuredData={this.state.structuredData}
        />
        <div
          className={
            !this.props.showSchedule
              ? !this.props.userProfile
                ? "player pb0 nonLogin"
                : "player pb0"
              : !this.props.userProfile
                ? "player pb0 nonLogin"
                : "player pb0"
          }
        >
          <div className="container">
            <div className="row">
              <div className="col-md-8 no-gutter-col">
                {this.props.liveStreamData && this.state.isSetEpg && (
                  <React.Fragment>
                    <Player
                      livePlayer={true}
                      videoUrl={this.props.liveStreamData.videoLiveStreamURL}
                      playerTimeout={
                        parseInt(this.props.liveStreamData.freeTimer) * 60
                      }
                      enableOverlayFun={this.enableOverlayFun}
                      token={this.props.token}
                      playVideo={checkLiveStream(this.props.token)}
                      showLive={this.state.showLive}
                      startPosition={this.state.currentSlideNumber}
                      data={this.state.epgData}
                    />
                    {!checkLiveStream(this.props.token) ||
                      this.state.enableOverlay ? (
                      <PlayerOverlay />
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                )}
              </div>
              <div className="col-md-4 showDetails">
                {this.state.currentShowData && (
                  <React.Fragment>
                    <p className="liveText">
                      <span className="liveCircle"></span>LIVE
                    </p>
                    {IsEmpty(this.state.currentShowData.eventSeries) && !IsEmpty(this.state.currentShowData.show) &&
                      <h1>{this.state.currentShowData.show}</h1>
                    }
                    {!IsEmpty(this.state.currentShowData.eventSeries) &&
                      <div
                        className="title-with-pic"
                      >
                        {!IsEmpty(this.state.currentShowData.eventSeries.url) &&
                          <div
                            className="circle-img"
                            onClick={event => {
                              redirectionWrapper(
                                'series',
                                event,
                                this.state.currentShowData.eventSeries.id,
                                this.state.currentShowData.eventSeries.name,
                                this.props,
                                this.props.showLoader,
                                this.props.hideLoader,
                                this.props.currentLanguage
                              )
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <img src={this.state.currentShowData.eventSeries.url} alt="" />
                          </div>
                        }
                        {IsEmpty(this.state.currentShowData.eventSeries.url) &&
                          <div
                            className="circle-img"
                            onClick={event => {
                              redirectionWrapper(
                                'series',
                                event,
                                this.state.currentShowData.eventSeries.id,
                                this.state.currentShowData.eventSeries.name,
                                this.props,
                                this.props.showLoader,
                                this.props.hideLoader,
                                this.props.currentLanguage
                              )
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <img src="/assets/ausbiz_series_logo.png" alt="" />
                          </div>
                        }
                        <h1 onClick={event => {
                          redirectionWrapper(
                            'series',
                            event,
                            this.state.currentShowData.eventSeries.id,
                            this.state.currentShowData.eventSeries.name,
                            this.props,
                            this.props.showLoader,
                            this.props.hideLoader,
                            this.props.currentLanguage
                          )
                        }}
                          style={{ cursor: "pointer" }}
                        >
                          {this.state.currentShowData.eventSeries.name}
                        </h1>
                        <div onClick={() => { this.followObject(this.state.currentShowData.eventSeries.id, 'series') }} className={this.state.currentShowData.eventSeries.isFollowing ? "hide" : "tick-icon"}></div>
                        <div className={this.state.currentShowData.eventSeries.isFollowing ? "tick-icon active" : "hide"}></div>
                      </div>
                    }

                    <div className={this.state.descHeight > 350 ? "livetv-info-toggle livetv-info-active" : "livetv-info-toggle"}>
                      {!IsEmpty(this.state.currentShowData.eventSeries) &&
                        <p
                          className="description"
                          dangerouslySetInnerHTML={getSeriesDescHtml(this.state.currentShowData.htmlSummary, this.state.currentShowData.eventSeries.description)}
                        >
                        </p>
                      }
                      {IsEmpty(this.state.currentShowData.eventSeries) && !IsEmpty(this.state.currentShowData.showSummary) &&
                        <p className="description">
                          {this.state.currentShowData.showSummary}
                        </p>
                      }
                      <div className="feature-expert-right">
                        {this.state.currentShowData.guest && (
                          <div className="guest-feature">
                            <h6>FEATURED GUESTS</h6>
                            <p>{this.state.currentShowData.guest}</p>
                          </div>
                        )}
                        {this.state.currentShowData.experts.length > 0 && (
                          <>
                            <h6>FEATURED EXPERTS</h6>
                            <ul className="feature-expert">
                              {this.state.currentShowData.experts.map((expert, expertIndex) => {
                                return (
                                  <li
                                    key={`currentEpgExpert-${expertIndex}`}
                                  >
                                    <div className="circle-img"
                                      onClick={event => {
                                        redirectionWrapper(
                                          'expert',
                                          event,
                                          expert.id,
                                          expert.name,
                                          this.props,
                                          this.props.showLoader,
                                          this.props.hideLoader,
                                          this.props.currentLanguage
                                        )
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img src={expert.url} alt="" />
                                    </div>
                                    <span
                                      onClick={event => {
                                        redirectionWrapper(
                                          'expert',
                                          event,
                                          expert.id,
                                          expert.name,
                                          this.props,
                                          this.props.showLoader,
                                          this.props.hideLoader,
                                          this.props.currentLanguage
                                        )
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {expert.name}
                                      <small>
                                        {expert.company}
                                      </small>
                                    </span>
                                    <div onClick={() => { this.followObject(expert.id, 'expert') }} className={expert.isFollowing ? "hide" : "tick-icon"}></div>
                                    <div className={expert.isFollowing ? "tick-icon active" : "hide"}></div>
                                  </li>
                                );
                              })
                              }
                            </ul>
                          </>
                        )}
                      </div>
                    </div>
                    {this.state.descHeight > 350 && <span className="toggle-text" onClick={this.toggleText}>show more</span>}
                  </React.Fragment>
                )}

              </div>
              <div className="col-md-12 showDetails pos-static">
                <div
                  className="toggleSchedule"
                  onClick={() => this.getSchedule()}
                >
                  Schedule
                  <span
                    className={
                      !this.props.showSchedule
                        ? "arrowSchedule"
                        : "arrowSchedule open"
                    }
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={"schedule schedule-section"}
        >
          <div className="schedule_wrapper">
            <div className="container">
              <div className="row">
                {!this.state.isSetEpg ? (
                  this.setEpg()
                ) : (
                  <EPG
                    showLive={this.state.showLive}
                    startPosition={this.state.currentSlideNumber}
                    funToday={this.setToday}
                    funTomorrow={this.setTomorrow}
                    data={this.state.epgData}
                    showSchedule={this.props.showSchedule}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {this.state.isSetHome && this.state.railData}
      </React.Fragment>
    );
  };
}


const mapStateToProps = state => {
  return {
    homePageData: state.home.homePageData,
    liveStreamData: state.home.liveStreamData,
    epgData: state.home.epgData,
    token: state.auth.token,
    userProfile: state.auth.userProfile,
    signUpModalStatus: state.signup.signUpModalStatus,
    currentLanguage: state.language.currentLanguage
  };
};

const mapDispatchToProps = dispatch => {
  // This might be the source of a future error with the home page rails not loading!
  return {
    getHomePageStructure: (language) => dispatch(getHomePageStructure(language)),
    getEpg: (token, language) => dispatch(getEpg(token, language)),
    resetEpgData: () => dispatch(resetEpgData()),
    getLiveStreamData: () => dispatch(getLiveStreamData()),
    getAutoRailHome: (url, railType, index) => dispatch(getAutoRailHome(url, railType, index)),
    setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm))
  };
};

function loadData(store) {
  const currentLanguage = store.getState().language.currentLanguage;
  // console.log("Calling loadData() on homepage:", currentLanguage);
  let actionArray = [
    store.dispatch(getHomePageStructureInitialLoad(currentLanguage)),
    store.dispatch(getEpgInitialLoad(currentLanguage)),
    store.dispatch(getLiveStreamDataInitialLoad()),
  ];
  return actionArray;
}

export default {
  loadData,
  component: connect(mapStateToProps, mapDispatchToProps)(memo(Home))
};
